import * as React from 'react'
import { GrPrice, makeRandomAlphaNumericString } from '../../../../../../../utilities/helpers'
import { TooltipWithIcon } from '../../../../../../../components/TooltipWithIcon'
import { Routes } from '../../../../../../../constants/Routes'
import { PurchaseOrderReceipt } from '@getgreenline/homi-shared'
import { SmartImage } from '../../../../../../../components/SmartImage'
import { Icon, Tooltip } from 'antd'

interface Props {
  companyId: number
  receiptResponse: PurchaseOrderReceipt
}

export const POImportProducts = (props: Props) => {
  const { companyId, receiptResponse } = props
  const { foundInProductListing, foundInCatalogue, notFound } = receiptResponse

  const productNameId = `product-list__product-name-${makeRandomAlphaNumericString()}`
  const foundProductIds = foundInProductListing.map((product) => product.productDetail.id)

  const unshippedProductCount = foundInProductListing.filter(
    (listing) => listing.caseCount === 0,
  ).length
  const uniqueFoundProductCount = new Set([...foundProductIds]).size
  const totalProductCount = uniqueFoundProductCount + foundInCatalogue.length + notFound.length

  return (
    <section className='product-list-wrapper'>
      <h6 className='pt-2 pb-2'>
        {`${
          uniqueFoundProductCount - unshippedProductCount
        } / ${totalProductCount} products can be imported`}
      </h6>

      <ul className='rounded product-list product-list__found'>
        {foundInProductListing.map((product, index) => {
          const { productDetail, caseCount, total, quantityPerCase, batchNumber } = product
          const { id: productId, parentProductId, sku, parentProductName, name } = productDetail
          const quantityDescription = `qty: ${caseCount} x ${quantityPerCase} units`

          return (
            <li key={`${index}_${productDetail.id}`} className='row ml-0 mr-0 mb-3'>
              <header className='d-flex justify-content-center product-list__header p-0 col-2'>
                <SmartImage className='w-100 rounded' src={productDetail.imageUrl} width={100} />
              </header>

              <main className='col-10 pr-0'>
                <a
                  className='product-list__link cursor-pointer'
                  href={Routes.EDIT_PRODUCT(companyId, parentProductId || productId)}
                  target='_blank'
                  rel='noreferrer'
                >
                  <h2 className='product-name' data-tip data-for={productNameId}>
                    {parentProductName ? `${parentProductName} - ${name} ` : `${name} `}

                    <TooltipWithIcon
                      tooltipId={productNameId}
                      place='bottom'
                      effect='float'
                      tooltipIconClassName='fa fa-external-link product-list__external-link ml-2'
                      tooltipContent='Click to open product page'
                    />
                  </h2>
                </a>

                {caseCount === 0 && (
                  <div className='mt-1 mb-1 product-warning'>
                    <b>
                      <Tooltip title='AGLC did not ship this product. It will not be imported to your purchase order.'>
                        <Icon className='mr-2' type='exclamation-circle' />
                      </Tooltip>

                      <span>product not shipped</span>
                    </b>
                  </div>
                )}

                <div className='product-list__description'>
                  <small>
                    <div>{`${sku} | ${quantityDescription}`}</div>
                    {batchNumber && (
                      <div>
                        Lot number: <b>{batchNumber}</b>
                      </div>
                    )}
                    <b>{`Total: ${GrPrice.renderDollarString(total)}`}</b>
                  </small>
                </div>
              </main>
            </li>
          )
        })}
      </ul>
    </section>
  )
}
